import { FC } from 'react';

import Chip from '@mui/material/Chip';

import css from '../SuspiciousUsersPage.module.css';

import { FingerprintModel } from 'v2/types/FingerprintModel';

interface SuspiciousUsersNicknamesColumnProps {
  fingerprint: FingerprintModel;
}

export const SuspiciousUsersNicknamesColumn: FC<SuspiciousUsersNicknamesColumnProps> = ({ fingerprint }) => (
  <div className={css.suspiciousUsersFingerprintNicknameChips}>
    {fingerprint.userNicknames.map((i) => (
      <Chip key={i} label={i} variant="outlined" size="small" />
    ))}
  </div>
);
